document.addEventListener('DOMContentLoaded', () => {
	document.addEventListener('click',(e)=>{
		if(e.target.classList.contains('accordion-heading') || e.target.closest('.accordion-heading')) {
			const accordion = e.target.closest('.accordion');
			if(accordion.classList.contains('open')) {
				closeAccordion(accordion);
			} else {
				openAccordion(accordion);
			}
		} else if(e.target.classList.contains('accordion')) {
			if(!e.target.classList.contains('link-container')) {
				if(!e.target.classList.contains('accordion__content') && !e.target.closest('.accordion__content')) {
					if(e.target.classList.contains('open')) {
						closeAccordion(e.target);
					} else {
						openAccordion(e.target);
					}
				}
			} else {
				if(e.target.classList.contains('open')) {
					closeAccordion(e.target);
				} else {
					openAccordion(e.target);
				}
			}
		}
	});
});
const openAccordion = (accordionItem) => {
	if(accordionItem instanceof Element) {
		if(accordionItem.getAttribute('type') === 'group') {
			const container = accordionItem.closest(accordionItem.getAttribute('container'));
			container.querySelectorAll('.accordion').forEach(accordionItem=>{
				closeAccordion(accordionItem);
			});
		}

		const accordionContent = accordionItem.querySelector('.accordion__content');
		accordionItem.classList.add('open');
		if(accordionContent) {
			accordionContent.style.height = `${accordionContent.scrollHeight}px`;
			accordionContent.style.paddingTop = '20px';
		}
	}
}
const closeAccordion = (accordionItem) => {
	if(accordionItem instanceof Element) {
		const accordionContent = accordionItem.querySelector('.accordion__content');
		accordionItem.classList.remove('open');
		if(accordionContent) {
			accordionContent.style.height = '0px';
			accordionContent.style.paddingTop = '0px';
		}
	}
}